.circular-progress {
  position: relative;
  height: 1.6rem;
  width: 1.6rem;
  border-radius: 50%;
  /* --progress-angle is set inline from the `progress` prop. */
  background: conic-gradient(
    #367bff var(--progress-angle),
    var(--color-grayscale-arsenic) var(--progress-angle)
  );
  transition: all 0.5s;

  &:before {
    content: '';
    height: 70%;
    width: 70%;
    position: absolute;
    background-color: #1f2023;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
